import { Rule } from '../rule.js'

export default [
  Rule({
    type: 'theme',
    details: {
      id: 'default-theme',
      title: 'Default theme',
      slug: 'default'
    }
  })
]
